import { render, staticRenderFns } from "./DITOverview.vue?vue&type=template&id=0828632f&scoped=true&"
import script from "./DITOverview.vue?vue&type=script&lang=js&"
export * from "./DITOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828632f",
  null
  
)

export default component.exports